"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
exports.__esModule = true;
var _1 = require("./");
exports.createGetBundlesFromAddresses = function (provider, caller) {
    var findTransactionObjects = _1.createFindTransactionObjects(provider);
    var getLatestInclusion = _1.createGetLatestInclusion(provider);
    /* tslint:disable-next-line:only-arrow-functions */
    return function (addresses, inclusionStates, callback) {
        if (caller !== 'lib') {
            /* tslint:disable-next-line:no-console */
            console.warn('`getBundlesFromAddresses()` has been deprecated and will be removed in v2.0.0' +
                'Please use `findTransactionObjects()` and `getBundle()` as an alternative');
        }
        // 1. Get txs associated with addresses
        return (findTransactionObjects({ addresses: addresses })
            // 2. Get all transactions by bundle hashes
            .then(function (transactions) {
            return findTransactionObjects({
                bundles: transactions
                    .map(function (tx) { return tx.bundle; })
                    .filter(function (bundle, i, bundles) { return bundles.indexOf(bundle) === i; })
            });
        })
            // 3. Group transactions into bundles
            .then(exports.groupTransactionsIntoBundles)
            // 4. If requested, add persistence status to each bundle
            .then(function (bundles) {
            return inclusionStates ? exports.addPersistence(getLatestInclusion, bundles) : bundles;
        })
            // 5. Sort bundles by timestamp
            .then(exports.sortByTimestamp)
            .asCallback(typeof arguments[1] === 'function' ? arguments[1] : callback));
    };
};
// Groups an array of transaction objects into array of bundles
exports.groupTransactionsIntoBundles = function (transactions) {
    return transactions.reduce(function (acc, transaction) {
        return transaction.currentIndex === 0 ? acc.concat([exports.getBundleSync(transactions, transaction)]) : acc;
    }, []);
};
// Collects all transactions of a bundle starting from a given tail and traversing through trunk.
exports.getBundleSync = function (transactions, transaction, bundle) {
    if (bundle === void 0) { bundle = []; }
    var bundleCopy = bundle.slice();
    if (transaction.currentIndex === 0) {
        bundleCopy.push(transaction);
    }
    if (transaction && transaction.currentIndex !== transaction.lastIndex) {
        var nextTrunkTransaction = transactions.find(function (nextTransaction) {
            return nextTransaction.hash === transaction.trunkTransaction &&
                nextTransaction.bundle === transaction.bundle &&
                nextTransaction.currentIndex === transaction.currentIndex + 1;
        });
        if (nextTrunkTransaction) {
            bundleCopy.push(nextTrunkTransaction);
            return exports.getBundleSync(transactions, nextTrunkTransaction, bundleCopy);
        }
    }
    return bundleCopy;
};
exports.zip2 = function (as, bs) {
    return as.map(function (a, i) {
        return [a, bs[i]];
    });
};
exports.zipPersistence = function (bundles) { return function (states) {
    // Since bundles are atomic, all transactions have the same state
    return exports.zip2(bundles, states).map(function (_a) {
        var bundle = _a[0], state = _a[1];
        return bundle.map(function (tx) { return (__assign({}, tx, { persistence: state })); });
    });
}; };
exports.addPersistence = function (getLatestInclusion, bundles) {
    // Get the first hash of each bundle
    var hashes = bundles.map(function (bundle) { return bundle[0].hash; });
    return getLatestInclusion(hashes).then(exports.zipPersistence(bundles));
};
exports.sortByTimestamp = function (bundles) {
    return bundles.slice().sort(function (_a, _b) {
        var a = _a[0];
        var b = _b[0];
        return a.attachmentTimestamp - b.attachmentTimestamp;
    });
};
//# sourceMappingURL=createGetBundlesFromAddresses.js.map